import React, { Component } from 'react'

import logoFD from '../images/logoFD.svg'
import logoFD_w from '../images/logoFD_w.svg'
import amexipacLogo from '../images/amexipac.svg'
import satPacLogo from '../images/pac_sat.svg'
import logo40aniv from '../images/40_aniversario_logo.png'
import prointegridad from '../images/prointegridad.svg';
//Christmas logo
//import logoFD_w from '../images/logoFD_w_xmas.png'

class MainMenu extends Component {

    render() {
        let url = ""
        return (
            <div uk-sticky="sel-target: .uk-background-main-menu">
                <div className="uk-container-expand uk-hidden@s uk-box-shadow-medium">
                    <div className="uk-navbar-container uk-background-default uk-navbar-transparent" uk-navbar={"true".toString()}>
                        <div className="uk-navbar-left">
                            <a href={url} className="uk-navbar-item uk-logo"><img src={logoFD} width="128" alt="logoFD" /></a>
                        </div>
                        <div className="uk-navbar-right">
                            <button className="uk-navbar-toggle " uk-navbar-toggle-icon={"true".toString()} uk-toggle="target: #offcanvas-menu"></button>
                        </div>
                    </div>
                </div>
                <div className="uk-container-expand uk-background-default uk-visible@s uk-box-shadow-medium">
                    <div className="uk-container">
                        <nav className="uk-navbar-container uk-navbar-transparent" uk-navbar={"true".toString()} id="mainMenu">
                            <div className="uk-navbar-left">
                                <ul className="uk-navbar-nav">
                                    <a className="uk-navbar-item uk-logo" href="/"><img src={logoFD} width="148" alt="logoFD" /> </a>
                                </ul>
                            </div>
                            <div className="uk-navbar-right">
                                <ul className="uk-navbar-nav">
                                    <li><a href="/">Inicio</a></li>
                                    <li>
                                        <a href={url} className="">Soluciones</a>
                                        <div className="uk-navbar-dropdown uk-background-submenu uk-border-rounded uk-padding-remove">
                                            <ul className="uk-nav uk-navbar-dropdown-nav">
                                                <li><a href="/soluciones/portal-de-facturacion-y-nomina-en-la-nube">Portal de facturación y nómina en la nube</a></li>
                                                <li><a href="/soluciones/timbrado-web-service">Timbrado Web Service</a></li>
                                                <li><a href="/soluciones/conector-digital">Conector Digital</a></li>
                                                <li><a href="/soluciones/kiosco-cfdi">Kiosco CFDI</a></li>
                                                <li><a href="/soluciones/distribuidores">Distribuidores</a></li>
                                                <li><a href="/soluciones/portal-autofactura">Portal Autofactura</a></li>
                                                <li><a href="/soluciones/validador-xml">Validador XML</a></li>
                                                <li><a href="/soluciones/addendador">Addendador</a></li>
                                                <li><a href="/soluciones/central-forsedi">Central Forsedi</a></li>
                                                <li><a href="/soluciones/descarga-cfdi">Descarga CFDI</a></li>
                                                <li><a href='/soluciones/conciliacion-xml'>Conciliaci&oacute;n XML</a></li>
                                                <li><a href="/partners/rh4000">RH4000</a></li>
                                                {/* <li><a href="/partners/aspel">Aspel</a></li>                                                            
                                                <li>
                                                    <a href="#" className="">Partners</a>
                                                    <div className="uk-navbar-dropdown uk-background-submenu uk-border-rounded uk-padding-remove" uk-dropdown="pos: right-center; delay-show: 300; delay-hide: 300">
                                                        <ul className="uk-nav uk-navbar-dropdown-nav">
                                                            <li><a href="/partners/rh4000" className="">RH4000</a></li>
                                                            <li><a href="/partners/aspel" className="">Aspel</a></li>                                                            
                                                        </ul>
                                                    </div>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </li>
                                    <li><a href="/precios" className="">Precios</a></li>
                                    <li>
                                        <a href="/nosotros" className="">Nosotros</a>
                                        {/* <div className="uk-navbar-dropdown uk-background-submenu uk-border-rounded uk-padding-remove">
                                            <ul className="uk-nav uk-navbar-dropdown-nav">
                                                <li><a href="/bolsa-de-trabajo">Bolsa de Trabajo</a></li>
                                            </ul>
                                        </div> */}
                                    </li>
                                    <li><a href="/contacto" className="">Contacto</a></li>
                                    <li>
                                        <a href={url} className="">Soporte</a>
                                        <div className="uk-navbar-dropdown uk-background-submenu uk-border-rounded uk-padding-remove">
                                            <ul className="uk-nav uk-navbar-dropdown-nav">
                                                {/* <li><a href="/enlaces-utiles">Enlaces Útiles</a></li> */}
                                                <li><a href="/preguntas-frecuentes">Preguntas Frecuentes</a></li>
                                                <li><a href="https://forsedi.facturacfdi.mx/developers/" target="_blank" rel="noreferrer">Sitio Desarrolladores</a></li>
                                            </ul>
                                        </div>
                                    </li>
                                    {/* <li className="uk-navbar-item"><a href="https://www.portal.facturacfdi.mx/" target="_blank" rel="noreferrer"><button className="uk-button topbar-buttons uk-button-small uk-border-rounded">Ingresar al portal</button></a></li> */}
                                    {/* <li><a href="https://www.amexipac.org/" target="_blank" rel="noreferrer" className=""><img src={amexipacLogo} width="64" alt="amexipac" /></a></li> */}
                                    <li><a href="http://omawww.sat.gob.mx/tramitesyservicios/Paginas/pac_formasdigitales.htm" target="_blank" rel="noreferrer"><img src={satPacLogo} width="32" alt="pacsat" /></a></li>
                                    <li><a href="#" rel="noreferrer"><img src={prointegridad} width="100" alt="pacsat" /></a></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}

export default MainMenu;